
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.322 8.902a6.99 6.99 0 00-.76 1.343A5 5 0 107 19.996h7.999c1.529 0 2.943-.49 4.094-1.322l-1.44-1.44a4.976 4.976 0 01-2.654.762H7a3 3 0 11.937-5.851A2 2 0 0010.4 11.03c.103-.24.224-.47.361-.69l-1.44-1.44zM19.103 15.855a5 5 0 00-6.961-6.962l-1.43-1.43a7 7 0 019.821 9.821l-1.43-1.43z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.293 3.289a1 1 0 011.414 0l18 18a1 1 0 01-1.414 1.414l-18-18a1 1 0 010-1.414z","fill":"currentColor"}})])
          )
        }
      }
    